// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12oXN","top":"styles_top__3C1eF"};